// @ts-nocheck

import React from 'react';
import styled, { keyframes } from 'styled-components';

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #000;
`;

const Text = styled.div`
  width: 80%;
  text-align: center;
  box-sizing: border-box;
  font-size: 2.5em;
  color: #ffc512;
  font-weight: bold;
  padding-bottom: 0.5em;
  font-family: BettingDropDeadGorgeous, sans-serif;
  padding-top: 1em;
  z-index: 5;
`;

const Ring = styled.div`
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
`;

const ringAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const RingChild = styled.div`
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 51px;
  height: 51px;
  margin: 6px;
  border: 6px solid #fff;
  border-radius: 50%;
  animation: ${ringAnimation} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #ffc512 transparent transparent transparent;
`;

const RingChild1 = styled(RingChild)`
  animation-delay: -0.45s;
`;

const RingChild2 = styled(RingChild)`
  animation-delay: -0.3s;
`;

const RingChild3 = styled(RingChild)`
  animation-delay: -0.15s;
`;

const SpinnerWithText = (props) => {
  const { text, className } = props;

  return (
    <FlexContainer className={className}>
      <Ring>
        <RingChild1 />
        <RingChild2 />
        <RingChild3 />
        <RingChild />
      </Ring>
      {text && <Text>{text}</Text>}
    </FlexContainer>
  );
};

export default SpinnerWithText;
